export const DEAL_RENT_HEADER_NEW_ITEM = 'deal_rent_head_new_item';
export const VALUATION_MY_HOME_V2 = 'valuation_my_home_header_v2';

export const EXPERIMENTS = [DEAL_RENT_HEADER_NEW_ITEM, VALUATION_MY_HOME_V2];
